import { Injectable } from '@angular/core';
import { IImageConfig } from '../../utils/image-config';
import * as Configs from '../../utils/image-config/configs/configs/index';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ImageSizeService {

	private URI_PROJECT = `/projects/${environment.projectId}`;

    getGenericImage(): IImageConfig {
        return Configs.General_Image
    }

    getInstanceByUrl(url: string): IImageConfig {

        const URI = decodeURIComponent(url).split(this.URI_PROJECT);
        if (URI.length < 1) {
            return Configs.General_Image
        }

        let imageConfigFind = Object.values(Configs).find(item => {

            for (const pathAccepted of item.pathAccepted) {
                const path = this.URI_PROJECT + URI[1]
                if (path.match(pathAccepted)) {
                    return true;
                }
            }

            return false;
        });

        if (!imageConfigFind) {
            imageConfigFind = Configs.General_Image
        }

        return imageConfigFind;
    }

}
